import React, { useState } from 'react';
import { Box } from '@mui/material';
import { v2Theme } from '../design/theme';
import TopBar from './TopBar';
import BottomNav from './BottomNav';
import SideMenu from './SideMenu';

export default function AppShell({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: v2Theme.palette.background,
        /* Space for fixed BottomNav (~56–72px) + home indicator */
        pb: 'calc(72px + env(safe-area-inset-bottom, 0px) + 8px)',
        overflowX: 'hidden',
      }}
    >
      <TopBar onOpenMenu={() => setMenuOpen(true)} />
      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Box component="main" sx={{ maxWidth: '100vw', overflowX: 'hidden' }}>{children}</Box>
      <BottomNav />
    </Box>
  );
}
